/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BookingSagasGetRateSuggestionsSagaQueryVariables = {
    customerId: string;
    pricelist: string;
    rate: string;
    rateDescription: string;
    showCustomerRates?: boolean | null | undefined;
    showMainRates?: boolean | null | undefined;
    showSubrates?: boolean | null | undefined;
    station: string;
    vehicleGroupId: string;
};
export type BookingSagasGetRateSuggestionsSagaQueryResponse = {
    readonly rateSuggestionList: {
        readonly rateSuggestions: ReadonlyArray<{
            readonly rate: string;
            readonly account: string | null;
            readonly description: string | null;
            readonly freeKm: number | null;
            readonly price: number | null;
            readonly priceAdditional: number | null;
            readonly priceAdditionalKm: number | null;
            readonly unit: string | null;
        } | null> | null;
    } | null;
};
export type BookingSagasGetRateSuggestionsSagaQuery = {
    readonly response: BookingSagasGetRateSuggestionsSagaQueryResponse;
    readonly variables: BookingSagasGetRateSuggestionsSagaQueryVariables;
};



/*
query BookingSagasGetRateSuggestionsSagaQuery(
  $customerId: String!
  $pricelist: String!
  $rate: String!
  $rateDescription: String!
  $showCustomerRates: Boolean
  $showMainRates: Boolean
  $showSubrates: Boolean
  $station: String!
  $vehicleGroupId: String!
) {
  rateSuggestionList(customerId: $customerId, pricelist: $pricelist, rate: $rate, rateDescription: $rateDescription, showCustomerRates: $showCustomerRates, showMainRates: $showMainRates, showSubrates: $showSubrates, station: $station, vehicleGroupId: $vehicleGroupId) {
    rateSuggestions {
      rate
      account
      description
      freeKm
      price
      priceAdditional
      priceAdditionalKm
      unit
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pricelist"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "rateDescription"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "showCustomerRates"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "showMainRates"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "showSubrates"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "station"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vehicleGroupId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerId",
        "variableName": "customerId"
      },
      {
        "kind": "Variable",
        "name": "pricelist",
        "variableName": "pricelist"
      },
      {
        "kind": "Variable",
        "name": "rate",
        "variableName": "rate"
      },
      {
        "kind": "Variable",
        "name": "rateDescription",
        "variableName": "rateDescription"
      },
      {
        "kind": "Variable",
        "name": "showCustomerRates",
        "variableName": "showCustomerRates"
      },
      {
        "kind": "Variable",
        "name": "showMainRates",
        "variableName": "showMainRates"
      },
      {
        "kind": "Variable",
        "name": "showSubrates",
        "variableName": "showSubrates"
      },
      {
        "kind": "Variable",
        "name": "station",
        "variableName": "station"
      },
      {
        "kind": "Variable",
        "name": "vehicleGroupId",
        "variableName": "vehicleGroupId"
      }
    ],
    "concreteType": "RateSuggestionList",
    "kind": "LinkedField",
    "name": "rateSuggestionList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RateSuggestion",
        "kind": "LinkedField",
        "name": "rateSuggestions",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "account",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "freeKm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "price",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceAdditional",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "priceAdditionalKm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "unit",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookingSagasGetRateSuggestionsSagaQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookingSagasGetRateSuggestionsSagaQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "07493e3c673ad638177939e366bbc66f",
    "id": null,
    "metadata": {},
    "name": "BookingSagasGetRateSuggestionsSagaQuery",
    "operationKind": "query",
    "text": "query BookingSagasGetRateSuggestionsSagaQuery(\n  $customerId: String!\n  $pricelist: String!\n  $rate: String!\n  $rateDescription: String!\n  $showCustomerRates: Boolean\n  $showMainRates: Boolean\n  $showSubrates: Boolean\n  $station: String!\n  $vehicleGroupId: String!\n) {\n  rateSuggestionList(customerId: $customerId, pricelist: $pricelist, rate: $rate, rateDescription: $rateDescription, showCustomerRates: $showCustomerRates, showMainRates: $showMainRates, showSubrates: $showSubrates, station: $station, vehicleGroupId: $vehicleGroupId) {\n    rateSuggestions {\n      rate\n      account\n      description\n      freeKm\n      price\n      priceAdditional\n      priceAdditionalKm\n      unit\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ca22c3e608a464c688311cca1ec29283';
export default node;
